<template>
  <Card class="mfm-list-card">
    <v-card v-for="(item, index) in items" :key="index" :class="[
      'mt-1 pt-4 px-4 card-item',
      item.feeder_id == selectedFeedId ? 'activelist' : '']" @click="clickItem(item)" hover>
      <div class="text-capitalize extraGreen--text fs-16">{{ item.type }}</div>
      <div>{{ item.name }}</div>
      <v-layout row wrap justify-start>
        <v-flex xs6 v-for="(param, index) in item.config" :key="index">
          <span>{{ $t(param.label) }} : <span :class="item[param.field] != null ? 'number--text' : 'error--text'">
              {{ item[param.field] == null ? 'No Data' : item[param.field] }}
            </span>
          </span>
        </v-flex>
      </v-layout>
      <v-divider v-if="index < items.length - 1" :key="`divider-${index}`"></v-divider>
    </v-card>
  </Card>
</template>

<script>
import { mapGettersMixin } from '@/util/mixin/index'
import list from '@/services/mfm.js'
import {
  mapMutations
} from 'vuex'
import moment from 'moment'
export default {
  mixins: [mapGettersMixin],
  props: {
    plantId: {
      type: Number,
      required: true,
    },
    blockId: {
      type: Number,
      required: true,
    },
    date: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      items: [],
      interval: null,
      selectedFeedId: 1,
      paramMap: {
        active_total_export_cumulative: { label: "Export (kWh)", field: "export" },
        active_total_import_cumulative: { label: "Import (kWh)", field: "import" },
        ac_power: { label: "AC Power (KW)", field: "ac_power" },
      },
      config: {}
    }
  },
  async mounted() {
    const response = await list.getMfmParams({ plantId: this.plantId, blockId: this.blockId });
    this.config = response.data.message
    const idParamMap = {};
    Object.keys(response.data.message).forEach(id => {
      idParamMap[id] = response.data.message[id].param
    })
    this.setIntervalWithoutDelay(() => this.callAllApi(idParamMap));
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME'
    ]),
    async callAllApi(idParamMap) {
      let updateTime = moment().format("MM-DD-YYYY H:mm:ss");
      this.SET_LAST_CALL_TIME(updateTime);
      await this.getListData(this.plantId, this.blockId, this.date, idParamMap);
    },
    async getListData(plantId, blockId, date, idParamMap) {

      let param = {
        plantId,
        blockId,
        date,
        idParamMap
      }

      let response = await list.getList(param)
      if (response.status === 200) {
        this.items = response.data.message.map(item => ({
          ...item,
          name: this.config[`${item.block_id}-${item.feeder_id}`].name,
          type: this.config[`${item.block_id}-${item.feeder_id}`].type,
          config: this.config[`${item.block_id}-${item.feeder_id}`].param.trim().split(',').map(p => {
            return this.paramMap[p]
          })
        }))
        this.$emit('initalGraph', response.data.message)
      }
    },
    clickItem(event) {
      this.selectedFeedId = event.feeder_id
      this.$emit('onClickCard', event)
    }
  },
  watch: {
    date() {
      this.callAllApi()
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }
}
</script>

<style scoped>
.mfm-list-card {
  height: calc(100vh - 297px);
  overflow: auto;
}

.card-item {
  background: var(--v-primary-base);
}

.activelist {
  border-radius: 2px;
  background-color: var(--v-primary-darken1);
}

.activelist .text--primaryText {
  color: var(--v-primaryText-base);
}

.card-item:hover {
  background: var(--v-sixth-base);
}
</style>
